export function sanitizeString(text: string = ''): string {
  return text
    .trim()                        // 1) 앞뒤 공백
    .replace(/ {2,}/g, ' ')        // 2) 중간 연속 공백 축소
    .replace(/[&<>"']/g, ch => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[ch]!));                      // 2) 5대 위험 문자만 엔티티 변환
}

/**
 * 이메일 마스킹
 * @param email 이메일
 * @returns 마스킹된 이메일
 */
export const maskEmail = (email: string | null) => {
  if (!email) return '';
  return email.replace(/(?<=^.)[^@]+(?=@)/g, match => '*'.repeat(match.length));
};